import authorize from './pages/authorize'
import user from './pages/user'
import studentuser from './pages/student_user'
import studentspace from './pages/studentspace'
import register from './pages/register'
import signUp from './pages/signUp'
import registerstudentpay from './pages/registerstudentpay'
import studentResults from './pages/studentresults'
import studyAbroad from './pages/studyAbroad'

const pageRouters = [
  authorize,
  user,
  studentuser,
  studentspace,
  register,
  signUp,
  registerstudentpay,
  studentResults,
  studyAbroad
]

export default pageRouters



// WEBPACK FOOTER //
// ./src/router/pageRouters.js